/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '.MuiPaper-root': { 
      borderRadius: `${pxToEm(12)} !important`,
      padding: pxToEm(8)
    }
  },
  pagesetupv2: {
    '& .innerWrap .configv2controller': {
      // borderBottom: 'none'
      margin: 0,
      padding: `0 ${pxToEm(24)}`,
      borderTopLeftRadius: pxToEm(8),
      borderTopRightRadius: pxToEm(8),
      border: 0,
      '& .title': {
        fontSize: pxToEm(16),
        minWidth: pxToEm(500)
      }
    },
    '& svg': {
      width: pxToEm(30)
    },
    paddingBottom: 0,
    '& .cardwrapper': {
      width: '100%',
      background: '#fff !important',
      padding: pxToEm(32),
      borderRadius: pxToEm(4),
      '&:hover': { boxShadow: 'none' }
    },
    '& .innerWrap': {
      padding: `24px !important`,
      margin: 0
    },
    '& .collapsable.opened': {
      maxHeight: '100% !important'
    }
  }
});
